import React, { useState } from 'react';
import {
  Box,
  Tabs,
  Tab,
  Paper,
} from '@mui/material';
import {
  CloudQueue as CloudIcon,
  Security as SecurityIcon,
  Settings as SettingsIcon,
  VpnKey as VpnKeyIcon,
} from '@mui/icons-material';
import { RancherManager } from './RancherManager';
import { VaultManager } from './VaultManager';
import { KubeconfigManager } from './KubeconfigManager';
import { KeycloakManager } from './KeycloakManager';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const TabPanel: React.FC<TabPanelProps> = ({ children, value, index }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`integrations-tabpanel-${index}`}
      aria-labelledby={`integrations-tab-${index}`}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
};

export const IntegrationsManager: React.FC = () => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  return (
    <Box>
      <Paper>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          aria-label="integrations tabs"
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab
            icon={<CloudIcon />}
            label="Rancher"
            id="integrations-tab-0"
            aria-controls="integrations-tabpanel-0"
          />
          <Tab
            icon={<SecurityIcon />}
            label="Vault"
            id="integrations-tab-1"
            aria-controls="integrations-tabpanel-1"
          />
          <Tab
            icon={<SettingsIcon />}
            label="Kubeconfigs"
            id="integrations-tab-2"
            aria-controls="integrations-tabpanel-2"
          />
          <Tab
            icon={<VpnKeyIcon />}
            label="Keycloak"
            id="integrations-tab-3"
            aria-controls="integrations-tabpanel-3"
          />
        </Tabs>
      </Paper>

      <TabPanel value={activeTab} index={0}>
        <RancherManager />
      </TabPanel>

      <TabPanel value={activeTab} index={1}>
        <VaultManager />
      </TabPanel>

      <TabPanel value={activeTab} index={2}>
        <KubeconfigManager />
      </TabPanel>

      <TabPanel value={activeTab} index={3}>
        <KeycloakManager />
      </TabPanel>
    </Box>
  );
};
